import { createTheme } from '@uhg-abyss/web/tools/theme';
import { Drawer } from '@uhg-abyss/web/ui/Drawer';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';

/* eslint-disable custom-rules/modal-and-drawer-requires-title */
import { Markdown } from '../../../common/Markdown';

const h3Style = {
  fontFamily: 'inherit',
  fontWeight: 700,
  fontSize: '16px',
  lineHeight: '1.4',
  letterSpacing: '0px',
  verticalAlign: 'middle',
  color: 'inherit',
  margin: '0 0 1em',
};

const DrawerHeading3 = ({ children }: { children: React.ReactNode }) => (
  <h3 style={h3Style}>{children}</h3>
);

const markdownOptions = {
  overrides: {
    h3: { component: DrawerHeading3 },
  },
};

export const InformationalDrawer = ({
  header,
  content,
  isDrawerOpen,
  setIsDrawerOpen,
}: {
  header: string;
  content: string;
  isDrawerOpen: boolean;
  setIsDrawerOpen: (isOpen: boolean) => void;
}) => {
  const handleOnClose = () => {
    setIsDrawerOpen(false);
  };
  const theme = createTheme('uhc', { enterpriseFont: true });

  return (
    <ThemeProvider theme={theme}>
      <Drawer
        css={{
          'abyss-modal-base-header-container': {
            padding: '16px',
          },
        }}
        data-testid="informational-drawer"
        header={header}
        isOpen={isDrawerOpen}
        onClose={handleOnClose}
        position="right"
        size="$sm"
      >
        <Markdown options={markdownOptions}>{content}</Markdown>
      </Drawer>
    </ThemeProvider>
  );
};
